import { render, staticRenderFns } from "./AdminMarketingContacts.vue?vue&type=template&id=2610eafb"
import script from "./AdminMarketingContacts.vue?vue&type=script&lang=js"
export * from "./AdminMarketingContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports